enum PropertyValuerValuationTypeEnum {
    Desktop = 'DESKTOP',
    Full = 'FULL',
}

export default PropertyValuerValuationTypeEnum;
